<template>
  <div class="social-icons-wrapper">
    <ul class="icon-holder">
      <li
        v-for="(acc, index) in activeSocials"
        :key="acc.name"
        :index="index"
      >
        <a
          target="_blank"
          rel="nofollow"
          :href="user.socialAccounts[acc].account"
          :class="`icon-${isMobileView ? 'sm' : 'lg' } icon-${acc !== 'website' ? `${acc} fab` : 'globe fas'}`"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['user', 'activeSocials']
}
</script>
<style lang="scss">
  @import 'assets/sass/icons';
</style>
